module.exports = __webpack_public_path__ + "img/news2.d9302e0d.png";